__turbopack_context__.v({
  "button": "CartSummary-module__rDFSVq__button",
  "couponField": "CartSummary-module__rDFSVq__couponField",
  "errorMessage": "CartSummary-module__rDFSVq__errorMessage",
  "input": "CartSummary-module__rDFSVq__input",
  "inputError": "CartSummary-module__rDFSVq__inputError",
  "root": "CartSummary-module__rDFSVq__root",
  "row": "CartSummary-module__rDFSVq__row",
  "textRight": "CartSummary-module__rDFSVq__textRight",
  "voucher": "CartSummary-module__rDFSVq__voucher",
  "vouchersList": "CartSummary-module__rDFSVq__vouchersList",
});
